import { render, staticRenderFns } from "./wxhealthytip.vue?vue&type=template&id=2923c390&scoped=true&"
import script from "./wxhealthytip.vue?vue&type=script&lang=js&"
export * from "./wxhealthytip.vue?vue&type=script&lang=js&"
import style0 from "./wxhealthytip.vue?vue&type=style&index=0&id=2923c390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923c390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2923c390')) {
      api.createRecord('2923c390', component.options)
    } else {
      api.reload('2923c390', component.options)
    }
    module.hot.accept("./wxhealthytip.vue?vue&type=template&id=2923c390&scoped=true&", function () {
      api.rerender('2923c390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxhealthytip.vue"
export default component.exports